// src/constants/appVersions.js

// valores estáveis, ligados à lógica do back (TextChoices). Enviar sempre o value.
export const PLATFORM = [
  { value: 'android', label: 'Android' },
  { value: 'ios', label: 'iOS' },
];

export const CHANNEL = [
  { value: 'store', label: 'Store' },
  { value: 'ota', label: 'OTA' },
];

export const RELEASE_TYPE = [
  { value: 'patch', label: 'Patch' },
  { value: 'minor', label: 'Minor' },
  { value: 'major', label: 'Major' },
];

// semver simples: MAJOR.MINOR.PATCH (espelha a validação do back)
const SEMVER_RE = /^\d+\.\d+\.\d+$/;

export function isValidSemver(version) {
  return SEMVER_RE.test(String(version || '').trim());
}